import { queryOptions } from '@tanstack/react-query';
import { inferenceHttp } from '@/lib/api/inference-client';
import { AudienceService, type AudienceSparkResponseDto } from '@inference.engine/api-client/web';
import { logger } from '@/lib/utils/logger';
import { PERSONA_SPARK_QUERY_KEYS } from './query-keys';

export const sparkByPersonaQuery = (personaId: string) =>
  queryOptions({
    queryKey: PERSONA_SPARK_QUERY_KEYS.detail(personaId),
    queryFn: () => sparkByPersona(personaId),
    staleTime: 5 * 60 * 1000,
  });

export const sparkByPersona = async (id: string): Promise<AudienceSparkResponseDto | null> => {
  try {
    const response = await AudienceService.generateAudienceSpark({
      client: inferenceHttp,
      path: { id },
    });
    return response.data ?? null;
  } catch (error) {
    logger.error('Failed to fetch sparks for persona:', error);
    return null;
  }
};
